import { Component } from '@angular/core';

@Component({
  selector: 'user-actions-default',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss'],
  standalone: false,
})
export class UserActionsDefaultComponent {}
